module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legacy-app",
    attrs: {
      "id": "app"
    }
  }, [_c('legacy-sunset-banner'), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a5d04f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 2010
// module chunks = 0